import { HttpInterceptorFn, HttpParams } from '@angular/common/http';

const INVALID_STRING_VALUES = new Set(['undefined', 'null']);

export const cleanHttpParamsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.params || !req.params.keys().length) {
    return next(req);
  }

  let cleanedParams = new HttpParams();

  req.params.keys().forEach(key => {
    const value = req.params.get(key);

    if (isValidValue(value)) {
      cleanedParams = cleanedParams.set(key, value);
    }
  });
  const newRequest = req.clone({ params: cleanedParams });

  return next(newRequest);
};

function isValidValue(value: string | null): value is string {
  return !!(value && !INVALID_STRING_VALUES.has(value));
}
